import { HTMLProps, ReactNode } from 'react';
import cn from 'classnames';

import styles from './Input.module.scss';

export type InputProps = {
  inputClassName?: string;
  leftContentClassName?: string;
  rightContentClassName?: string;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  isActive?: boolean;
  error?: boolean;
  size?: 'l' | 'm' | 's' | 'xs';
  variant?: 'primary' | 'secondary' | 'transparent' | 'search';
  tip?: ReactNode;
};

export function Input({
  leftContent,
  rightContent,
  error,
  size = 'm',
  className,
  leftContentClassName,
  rightContentClassName,
  inputClassName,
  isActive = false,
  readOnly = false,
  variant = 'primary',
  tip,
  value,
  ...otherProps
}: InputProps & Omit<HTMLProps<HTMLInputElement>, 'size'>): JSX.Element {
  return (
    <label
      className={cn(
        styles.label,
        styles[variant],
        {
          [styles.error]: error,
          [styles.active]: isActive,
          [styles.disabled]: otherProps.disabled,
          [styles.readOnly]: readOnly,
          [styles.small]: size === 's',
          [styles.xSmall]: size === 'xs',
          [styles.large]: size === 'l',
        },
        className,
      )}
    >
      {leftContent !== undefined && (
        <div className={cn(styles.leftContent, leftContentClassName)}>
          {leftContent}
        </div>
      )}
      <div className={styles.inputContainer}>
        <input
          className={cn(styles.input, inputClassName)}
          type="text"
          value={value}
          {...otherProps}
        />
        {/* TODO: center this */}
        {tip !== undefined && value !== '' && (
          <span
            className={cn(styles.input, inputClassName, styles.tipContainer)}
          >
            <span className={styles.tipValue}>{value}</span>{' '}
            <span className={styles.tip}>{tip}</span>
          </span>
        )}
      </div>

      {rightContent !== undefined && (
        <div className={cn(styles.rightContent, rightContentClassName)}>
          {rightContent}
        </div>
      )}
    </label>
  );
}
